import { Modal, ModalBody, ModalContent, ModalHeader } from '@nextui-org/react';
import React from 'react';
import { QuizData } from '../App';
import FillInBlanksQuiz from './FiBQuiz/FillInBlanksQuiz';
import MatchPairsModal from './MatchPairsQuiz/MatchPairs';
import MultipleChoiceQuestionQuiz from './McqQuiz/MultipleChoiceQuestionQuiz';

interface QuizModalProps {
  isOpen: boolean;
  onClose: () => void;
  quiz: QuizData;
  time: number;
  correctMap: Map<string, boolean>;
  setCorrectMap: (correctMap: Map<string, boolean>) => void;
  handleQuizAttemptEvent: any;
}

export interface QuizProps {
  submitted: boolean;
  correct: boolean;
  setCorrect: (correct: boolean) => void;
  setSubmitted: (submitted: boolean) => void;
  handleNextQuiz: () => void;
  handlePreviousQuiz: () => void;
  selectedQuiz: number;
  numberOfQuiz: number;
  onClose: () => void;
  triesCounter: number;
  setTriesCounter: (submitCount: number) => void;
}

const QuizModal = (props: QuizModalProps) => {
  const [submitted, setSubmitted] = React.useState<Map<string, boolean>>(
    new Map<string, boolean>()
  );
  const [selectedQuiz, setSelectedQuiz] = React.useState<number>(0);
  const [quizSubmissions, setQuizSubmissions] = React.useState<Map<string, any | undefined>>(
    new Map<string, object | undefined>()
  );
  const [triesCounter, setTriesCounter] = React.useState<Map<string, number>>(
    new Map<string, number>()
  );

  const getQuizIndex = (quizType: string, index: number) => {
    return quizType + index + props.time;
  };

  const resetQuizState = () => {
    const currentQuizIndex = getQuizIndex(props.quiz[selectedQuiz].type, selectedQuiz);
    setSubmitted(new Map(submitted.set(currentQuizIndex, false)));
    //not sure what was the use case for this line, keeping it for now.
    //props.setCorrectMap(new Map(props.correctMap.set(currentQuizIndex, false)));
    setQuizSubmissions(new Map(quizSubmissions.set(currentQuizIndex, undefined)));
    setTriesCounter(new Map(triesCounter.set(currentQuizIndex, 0)));
  };
  const handleNextQuiz = () => {
    console.log('handleNextQuiz called');
    if (selectedQuiz < props.quiz.length - 1) {
      resetQuizState();
      setSelectedQuiz(selectedQuiz + 1);
    }
  };

  const handlePreviousQuiz = () => {
    console.log('handlePreviousQuiz called');
    if (selectedQuiz > 0) {
      resetQuizState();
      setSelectedQuiz(selectedQuiz - 1);
    }
  };

  const closeQuizModal = () => {
    props.onClose();
    resetQuizState();
    setSelectedQuiz(0);
  };

  if (props.quiz.length === 0) return null;
  const quizMap: Map<string, React.ReactNode> = new Map<string, React.ReactNode>();
  props.quiz.forEach((quiz, index) => {
    switch (quiz.type) {
      case 'match_pairs':
        quizMap.set(
          getQuizIndex(quiz.type, index),
          <MatchPairsModal
            quiz={quiz}
            submitted={submitted.get(getQuizIndex(quiz.type, index)) || false}
            setSubmitted={(sub) => {
              setSubmitted(new Map(submitted.set(getQuizIndex(quiz.type, index), sub)));
            }}
            correct={props.correctMap.get(getQuizIndex(quiz.type, index)) || false}
            setCorrect={(corr) => {
              props.setCorrectMap(
                new Map(props.correctMap.set(getQuizIndex(quiz.type, index), corr))
              );
            }}
            handleNextQuiz={handleNextQuiz}
            handlePreviousQuiz={handlePreviousQuiz}
            selectedQuiz={selectedQuiz}
            numberOfQuiz={props.quiz.length}
            onClose={closeQuizModal}
            submission={quizSubmissions.get(getQuizIndex(quiz.type, index))}
            setSubmission={(submission) => {
              setQuizSubmissions(
                new Map(quizSubmissions.set(getQuizIndex(quiz.type, index), submission))
              );
              props.handleQuizAttemptEvent(
                getQuizIndex(quiz.type, index),
                props.correctMap.get(getQuizIndex(quiz.type, index))
              );
            }}
            triesCounter={triesCounter.get(getQuizIndex(quiz.type, index)) || 0}
            setTriesCounter={(tries) => {
              setTriesCounter(new Map(triesCounter.set(getQuizIndex(quiz.type, index), tries)));
            }}
          />
        );
        break;
      case 'multiple_choice':
        quizMap.set(
          getQuizIndex(quiz.type, index),
          <MultipleChoiceQuestionQuiz
            quiz={quiz}
            submitted={submitted.get(getQuizIndex(quiz.type, index)) || false}
            setSubmitted={(sub) => {
              setSubmitted(new Map(submitted.set(getQuizIndex(quiz.type, index), sub)));
            }}
            correct={props.correctMap.get(getQuizIndex(quiz.type, index)) || false}
            setCorrect={(corr) => {
              props.setCorrectMap(
                new Map(props.correctMap.set(getQuizIndex(quiz.type, index), corr))
              );
            }}
            handleNextQuiz={handleNextQuiz}
            handlePreviousQuiz={handlePreviousQuiz}
            selectedQuiz={selectedQuiz}
            numberOfQuiz={props.quiz.length}
            onClose={closeQuizModal}
            submission={quizSubmissions.get(getQuizIndex(quiz.type, index))}
            setSubmission={(submission) => {
              setQuizSubmissions(
                new Map(quizSubmissions.set(getQuizIndex(quiz.type, index), submission))
              );
              props.handleQuizAttemptEvent(
                getQuizIndex(quiz.type, index),
                props.correctMap.get(getQuizIndex(quiz.type, index))
              );
            }}
            triesCounter={triesCounter.get(getQuizIndex(quiz.type, index)) || 0}
            setTriesCounter={(tries) => {
              setTriesCounter(new Map(triesCounter.set(getQuizIndex(quiz.type, index), tries)));
            }}
          />
        );
        break;
      case 'fill_in_blanks':
        quizMap.set(
          getQuizIndex(quiz.type, index),
          <FillInBlanksQuiz
            quiz={quiz}
            submitted={submitted.get(getQuizIndex(quiz.type, index)) || false}
            setSubmitted={(sub) => {
              setSubmitted(new Map(submitted.set(getQuizIndex(quiz.type, index), sub)));
            }}
            correct={props.correctMap.get(getQuizIndex(quiz.type, index)) || false}
            setCorrect={(corr) => {
              props.setCorrectMap(
                new Map(props.correctMap.set(getQuizIndex(quiz.type, index), corr))
              );
            }}
            handleNextQuiz={handleNextQuiz}
            handlePreviousQuiz={handlePreviousQuiz}
            selectedQuiz={selectedQuiz}
            numberOfQuiz={props.quiz.length}
            onClose={closeQuizModal}
            submission={quizSubmissions.get(getQuizIndex(quiz.type, index))}
            setSubmission={(submission) => {
              setQuizSubmissions(
                new Map(quizSubmissions.set(getQuizIndex(quiz.type, index), submission))
              );
              props.handleQuizAttemptEvent(
                getQuizIndex(quiz.type, index),
                props.correctMap.get(getQuizIndex(quiz.type, index))
              );
            }}
            triesCounter={triesCounter.get(getQuizIndex(quiz.type, index)) || 0}
            setTriesCounter={(tries) => {
              setTriesCounter(new Map(triesCounter.set(getQuizIndex(quiz.type, index), tries)));
            }}
          />
        );
        break;
    }
  });
  const selectedQuizIndex = props.quiz[selectedQuiz].type + selectedQuiz + props.time;
  const currentlySelectedQuizNode = quizMap.get(selectedQuizIndex);
  return (
    <Modal
      isOpen={props.isOpen}
      onClose={closeQuizModal}
      size="2xl"
      isDismissable={false}
      hideCloseButton={true}
    >
      <ModalContent
        className={
          props.correctMap.get(selectedQuizIndex)
            ? 'bg-green-200'
            : submitted.get(selectedQuizIndex)
            ? 'bg-red-200'
            : '' + 'transition delay-300'
        }
      >
        <ModalHeader>Quiz</ModalHeader>
        <ModalBody>
          <div className="w-full h-full p-2">{currentlySelectedQuizNode}</div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default QuizModal;
